import { SessionNotificationDeliveryEnum } from "~/utils/enums/session-notifications.enums";

/** The chooser's branches the attendees' send form serves; the others are sends of the session itself. */
export type AttendeesDeliveryChoice =
  SessionNotificationDeliveryEnum.PARTICIPANTS | SessionNotificationDeliveryEnum.MANAGERS;

export function isAttendeesDeliveryChoice(choice: SessionNotificationDeliveryEnum): choice is AttendeesDeliveryChoice {
  return choice === SessionNotificationDeliveryEnum.PARTICIPANTS || choice === SessionNotificationDeliveryEnum.MANAGERS;
}
